// ====================================================
// src/components/block/liveStreamManagement/enchainements/HorlogeEnchainement.tsx
//
// Balayage radial façon aiguille d'horloge : démarre à midi, tourne dans le
// sens horaire jusqu'à recouvrir tout le cadre. Pas de réglage pour l'instant.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface HorlogeConfig {}

class HorlogeEnchainementImpl extends Enchainement<HorlogeConfig> {
  readonly id = 'horloge';
  readonly label = 'Horloge';
  readonly icon = 'Clock';
  readonly defaultConfig: HorlogeConfig = {};

  render(input: EnchainementRenderInput, _config: HorlogeConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;

    // Flux final fixe en fond, plein cadre.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    if (progress <= 0) return;

    const cx = width / 2, cy = height / 2;
    // Rayon nécessaire pour couvrir les coins, quel que soit le ratio du cadre.
    const maxR = Math.sqrt(cx * cx + cy * cy);
    const startAngle = -Math.PI / 2; // midi
    const endAngle   = startAngle + progress * Math.PI * 2;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, maxR, startAngle, endAngle);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls(_props: EnchainementControlProps<HorlogeConfig>) {
    return null;
  }
}

export const horlogeEnchainement = new HorlogeEnchainementImpl();
